module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-779.575f2e37.jpg";